import i18n from '@i18next/i18n';

export const dbBrokenText = i18n.t('暂时无法本地缓存，请保持联网以同步数据');
export const mutexLockText = i18n.t('文档被多个标签页同时打开，请关闭其他标签页后刷新');
